import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import NumberSelectButton from '../ninjas/NumberSelectButton';
import IntroScreenBase from './IntroScreenBase';
import TitleScreenBase from './TitleScreenBase';
import ABCyaLib from '@abcya/abcya_lib';

export default class TitleMultiplesScreen extends TitleScreenBase {
  init() {
    super.init();

    this.lblSubtitle = null;
  }

  create() {
    super.create();

    this.titleStamp.setFrame(ABCyaLib.Environment.instance.gameConfig.subtitle);

    this.lblSubtitle = ABCyaPhaser.Text.addText(this.scale.width / 2,520, `${ABCyaLib.Environment.instance.gameConfig.titleInstructionTextFontSize}pt`, 0xffffff, FontKeys._cf_samurai_bobregular, ABCyaLib.Environment.instance.gameConfig.titleInstructionText, this, true).setOrigin(0.5);
    this.children.moveBelow(this.lblSubtitle, this.btnContainer);

    this.titleStamp.x = 880;
    this.titleStamp.y = 340;

    this.btnContainer.y = this.lblSubtitle.y + 55;
  }

  createButtonContainer() {
    super.createButtonContainer();

    const numberOptions = ABCyaLib.Environment.instance.gameConfig.options;
    if (numberOptions === null) {
      let curX = 80; const xOffset = 80; const yOffset = 80; let curCol = 1;
      for (let i = 0; i < 12; i++) {
        if (i === 5) {
          curCol = 2;
          curX = 0;
        }
        const btn = new NumberSelectButton(this, i + 2);
        btn.x = curX;
        btn.y = yOffset * (curCol - 1);
        curX += xOffset;
        btn.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onClickOptionButton(btn), this);
        this.btnContainer.add(btn);
      }
    }
    else {
      let curX = 0; const xOffset = 80;
      for (let i = 0; i < numberOptions.length; i++) {
        const btn = new NumberSelectButton(this, numberOptions[i]);
        btn.x = curX;
        btn.y = 0;
        curX += xOffset;
        btn.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onClickOptionButton(btn), this);
        this.btnContainer.add(btn);
      }
      this.btnContainer.x = 0;
    }
  }

  /**
   * 
   * @param {NumberSelectButton} sender 
   */
  onClickOptionButton (sender) {
    if (sender.num === 13) {
      gameData.gameMode = Phaser.Math.Between(2, 12);
    }
    else {
      gameData.gameMode = sender.num;
    }

    this.scene.start(IntroScreenBase.KEY);
  }
}